import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, HideScrollbar } from '../../../global/commonStyle';

interface Props {
  newGroup?: boolean;
  isActive?: boolean;
  showGap?: boolean;
  isReply?: boolean;
  isProjectMessageDetail?: boolean;
  isOverflowHidden?: boolean;
  isDisabled?: boolean;
  hasUserImage?: boolean;
  isFirstUserMessage?: boolean;
  isLastUserMessage?: boolean;
  isReaction?: boolean;
  isKeyboardVisible?: boolean;
  responsiveBottomSpacing?: string;
  selectFileResponsive?: boolean;
}

const Group = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  height: 100%;
  ${(props: Props) =>
    props.isProjectMessageDetail &&
    css`
      height: calc(100dvh - 47px);
    `}
  ${mobile_xl(css<Props>`
    height: ${({ newGroup, isProjectMessageDetail, selectFileResponsive }) =>
      newGroup || isProjectMessageDetail ? 'calc(100dvh - 128px)' : selectFileResponsive ? '' : 'calc(100dvh - 80px)'};
  `)}
`;

const LeftDiv = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  margin: var(--space-0) auto;
  position: relative;
  .infinite-scroll-component {
    overflow: visible !important;
  }
  ${HideScrollbar}
  ${(props: Props) =>
    props.isOverflowHidden &&
    css`
      overflow: hidden;
    `}
`;

const DiscussDiv = styled.div<Props>`
  width: 100%;
  ${AlignCenter}
  flex-direction: column;
  margin-bottom: var(--space-12);
  ${mobile_xl(css<Props>`
    margin-bottom: ${({ responsiveBottomSpacing }) =>
      responsiveBottomSpacing ? responsiveBottomSpacing : 'var(--space-96)'};
  `)}
`;

const TopDiv = styled.div`
  display: block;
  max-width: 715px;
  width: 100%;
`;

const ScrollRef = styled.div``;

const Footer = styled.div<Props>`
  position: sticky;
  bottom: 0;
  padding-bottom: var(--space-24);
  z-index: var(--z-index-99);
  max-width: 715px;
  width: 100%;
  margin: var(--space-0) auto;
  background: var(--background-secondary);
  ${mobile_xl(css`
    padding-block: var(--space-6) var(--space-16);
    width: 100%;
    bottom: 0;
  `)}
`;
const Message = styled.div`
  position: relative;
  bottom: 0;
`;

const FolderRight = styled.div<Props>`
  max-width: 350px;
  width: 100%;
  background: var(--background-secondary);
  height: calc(100dvh - 47px);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${HideScrollbar}

  ${(props: Props) =>
    props.isProjectMessageDetail &&
    css`
      padding-right: var(--space-0);
    `}
`;

// Row above the oldest message while an older page loads. The list is bottom-anchored, so adding
// or removing it doesn't move the messages in view.
const OlderMessagesLoader = styled.div`
  display: flex;
  justify-content: center;
  padding-block: var(--space-12);
`;

const MessagesDivMain = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-0);
  `)}
`;

export {
  DiscussDiv,
  FolderRight,
  Footer,
  Group,
  LeftDiv,
  Message,
  OlderMessagesLoader,
  ScrollRef,
  TopDiv,
  MessagesDivMain
};
